exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".productdetailpopup::-webkit-scrollbar {\n  display: none;\n}\n\n.strike {\n  text-decoration: line-through;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/product/product-preview/product-preview.component.scss
// module id = ../../../../../src/app/components/product/product-preview/product-preview.component.scss
// module chunks = main